<script lang="ts">
import { watch } from 'vue';

import type { LightboxComponents, LightboxVideoItem } from './phxsg-lightbox.vue';

interface PhxsgLightboxVideoItemProps {
  item: LightboxVideoItem;
  components: LightboxComponents;
}
</script>

<script setup lang="ts">
const props = defineProps<PhxsgLightboxVideoItemProps>();

watch(
  () => props.components.videoPlayerComponent,
  (component) => {
    if (!component) {
      console.warn('[phxsg-lightbox] Missing videoPlayerComponent for video lightbox item.');
    }
  },
  { immediate: true },
);
</script>

<template>
  <component
    :is="components.videoPlayerComponent"
    v-if="components.videoPlayerComponent"
    :sources="item.data.sources"
    :poster="item.data.poster"
    :autoplay="item.data.autoplay ?? false"
    :lazy="false"
    class="phxsg-lightbox__video-player"
  />
</template>
